module.exports = __webpack_public_path__ + "img/goldpostlogo.d51f244b.png";